import React from "react";
import { useTranslation } from "react-i18next";
import { ModeTabsSlot } from "@/app/components/ModeTabs/ModeTabsPortal";
import { BackgroundStripes } from "@/ui/BackgroundStripes/BackgroundStripes";
import { GiftIcon } from "./icons";
import cls from "./styles.module.scss";

interface RaffleEmptyStateProps {
  rootClassName: string;
}

export const RaffleEmptyState = ({ rootClassName }: RaffleEmptyStateProps) => {
  const { t } = useTranslation();

  return (
    <section className={rootClassName}>
      <BackgroundStripes color="yellow" className={cls.backgroundStripes} />
      <div className={[cls.content, cls.contentReady].join(" ")}>
        <ModeTabsSlot className={cls.modeTabs} />
        <div className={cls.emptyState}>
          <div className={cls.emptyStateIcon} aria-hidden="true">
            <GiftIcon />
          </div>
          <div className={cls.emptyStateCopy}>
            <h1 className={cls.emptyStateTitle}>{t("raffle.empty.title")}</h1>
            <p className={cls.emptyStateSubtitle}>
              {t("raffle.empty.subtitle")}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
